import React, { useState, useContext } from "react"
import { RootContext } from 'RootContext';

//Pegaso components
import ErrorUtils from "components/Tools/ErrorUtils"
import { fetchWithToken } from "components/Fetch/api-fetch"

//import CSS
import SupportDialog from "./SupportDialog";

export default function Support() {
  const { companyId, t, apiUrl, access_token, refresh_token, setAccess_token, getLab, isLabUser, getExistsExternalSystem } = useContext(RootContext)
  const { labId, } = getLab()
  const currentYear = new Date().getFullYear()
  const [dialogMsg, setDialogMsg] = useState("")
  const [endReprintJobId, setEndReprintJobId] = useState("")
  const [endRestoreJobId, setEndRestoreJobId] = useState("")
  const [openPanelReprint, setOpenPanelReprint] = useState(false)
  const [openPanelRestore, setOpenPanelRestore] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [startReprintJobId, setReprintStartJobId] = useState("")
  const [startRestoreJobId, setRestoreStartJobId] = useState("")
  const [yearReprint, setYearReprint] = useState(currentYear)
  const [yearRestore, setYearRestore] = useState(currentYear)


  /*
    HANDLER
  */

  const handlePrintJobs = () => {
    const url = `${apiUrl}/companies/${companyId}/labs/${labId}/year/${yearReprint}/startJodId/${startReprintJobId}/endJodId/${endReprintJobId}/printMultiRequest`
    fetchWithToken(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token,
    })
      .then((response) => {
        return response.body
      })
      .then((data) => {
        setDialogMsg(t("10479"))
        setOpenDialog(true)
      })
      .catch((err) => {
        setDialogMsg(t("1"))
        setOpenDialog(true)
        ErrorUtils.errorLog(`${url} => handlePrint Error`, err.message)
      })
  }

  const handleRestoreJobs = () => {
    const url = `${apiUrl}/companies/${companyId}/labs/${labId}/year/${yearRestore}/startJodId/${startRestoreJobId}/endJodId/${endRestoreJobId}/restoreMultipleForExternalSystem`
    fetchWithToken(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token,
    })
      .then((response) => {
        return response.body
      })
      .then((data) => {
        setDialogMsg(t("Job rispristinati correttamente"))
        setOpenDialog(true)
      })
      .catch((err) => {
        setDialogMsg(t("1"))
        setOpenDialog(true)
        ErrorUtils.errorLog(`${url} => handlePrint Error`, err.message)
      })
  }


  return (
    <div>

      {/* RISTAMPA ORDINE MULTIPLO*/}
      <SupportDialog
        buttonWord={"10104"}
        dialogMsg={dialogMsg}
        endJobId={endReprintJobId}
        titleWord={"10478"}
        handleSave={handlePrintJobs}
        openPanel={openPanelReprint}
        openDialog={openDialog}
        setOpenPanel={setOpenPanelReprint}
        setEndJobId={setEndReprintJobId}
        setStartJobId={setReprintStartJobId}
        setYear={setYearReprint}
        setOpenDialog={setOpenDialog}
        startJobId={startReprintJobId}
      />



      {/* RIPRISTINO ORDINE MULTIPLO*/}
      {isLabUser() && getExistsExternalSystem() ?
        <SupportDialog
          dialogMsg={dialogMsg}
          buttonWord={"Ripristina"}
          endJobId={endRestoreJobId}
          titleWord={"Ripristino montaggio multiplo"}
          handleSave={handleRestoreJobs}
          openPanel={openPanelRestore}
          openDialog={openDialog}
          setOpenPanel={setOpenPanelRestore}
          setEndJobId={setEndRestoreJobId}
          setStartJobId={setRestoreStartJobId}
          setYear={setYearRestore}
          setOpenDialog={setOpenDialog}
          startJobId={startRestoreJobId}
        />
        : null
      }




    </div>
  )
}
